
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Box, Button, Dialog, DialogContent, FormControlLabel, IconButton, Radio, RadioGroup, TextField, Typography } from "@mui/material"
import ModAccName from "components/ModAccName";
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader";
import { initDialogData, jobColNm, jobApiNm } from "constants/jobConstant";
import useDialogOpen from "hooks/useDialogOpen";
import ComboBox from "components/ComboBox";
import { validate, loadMSData, addIdForDataGrid } from "utils";
import { GlobalStateContext } from "contexts/GlobalStateContext";
import PaperComponent from "components/PaperComponent";
import { alertConfirmDelete, alertError, alertWarning } from "components/Alert";
import { initFileUploadData } from "constants/fileUploadConstant";
import { saveFile } from "components/FileUplaod/saveFile";
import { FOLDER_JOB_FILE } from "constants/serverConstant";
import FileUpload from "components/FileUplaod/FileUpload";
import CheckboxFormControl from "components/CheckboxFormControl";
import { BoxFC, BoxFR } from "components/BoxCustom";
import TagBox from "components/TagBox";
import TextFieldChangeLanguage from "components/TextFieldChangeLanguage";
import CustomerDialog from "../CustomerManagement/CustomerDialog";
import POIDialog from "../POIManagement/POIDialog";
import { CancelRounded, CloudDownloadRounded, ContentCopyRounded, HistoryRounded, RouteRounded, SearchRounded } from "resource/muiImport";
import LogTableDialog from "components/LogTableDialog/LogTableDialog";
import SearchCompanyAddrDialog from "components/SearchCompanyAddrDialog";
import { cusApiNm } from "constants/cusConstant";
import ExpenseJobDefaultDialog from "./ExpenseJobDefaultDialog";
import ExpensePOIDialog from "./ExpensePOIDialog";
import ExpenseJobDialog from "./ExpenseJobDialog";
import { endAdornmentProps } from "utils/bahtProps";
import { poiApiNm } from "constants/POIConstant";

const excludeKeys = ["JobLogId", "JobId", "ModDte", "ModAcc"]
let originalDialogData = null
let originalTagIds = []
//let initCenter = null
let jobId = null
const JobDialog = ({ state, fn }) => {
  const { dialogOpen, selectedId, selectedCusId } = state
  const [dialogSearchAddrOpen, setDialogSearchAddrOpen] = useState(false)
  const { setDialogOpen, onFinish } = fn
  const [dialogData, setDialogData] = useState(initDialogData)
  const [fileUploadData, setFileUploadData] = useState(initFileUploadData())
  const [tagData, setTagData] = useState([])
  const [dialogCusOpen, setDialogCusOpen] = useState(false)
  const [dialogPOIOpen, setDialogPOIOpen] = useState(false)
  const { ax, msData, setMSData } = useContext(GlobalStateContext)
  const [dialogExpenseJobDefaultOpen, setDialogExpenseJobDefaultOpen] = useState(false)
  const [dialogExpensePOIOpen, setDialogExpensePOIOpen] = useState(false)
  const [dialogExpenseJobOpen, setDialogExpenseJobOpen] = useState(false)
  const [dialogHistoryOpen, setDialogHistoryOpen] = useState(false)
  const [expensePOIdataTable, setExpensePOIDataTable] = useState([])
  const [expenseJobdataTable, setExpenseJobDataTable] = useState([])

  // const latLng = useMemo(() => {
  //   const { Lat, Lng } = dialogData    
  //   return Lat === null || Lng === null ? null : { Lat, Lng }
  // }, [dialogData])

  const poiComboMod = useMemo(() => {

    const jobLoc = []
    const otherLoc = []
    for (const item of msData.poiComboWithAdd) {
      if (item.refId === 4) {
        jobLoc.push(item)
      } else {
        otherLoc.push(item)
      }
    }
    const orderedData = [...jobLoc, ...otherLoc]
    if (selectedCusId > 0) {
      return orderedData
    } else {
      const modData = orderedData.filter(item => item.id > 0)
      modData.unshift({ id: -1, label: "เพิ่ม สถานที่", group: "เพิ่มข้อมูล" })
      return modData
    }
  }, [msData.poiComboWithAdd, selectedCusId])

  const modifyData = useCallback((dialogData) => {
    dialogData.IsHeadBrch = dialogData.RcptBrchNo === 0 ? 1 : 0
    const serverFiles = dialogData.Files.map(item => ({
      id: item.JobFileId,
      fileNm: item.FileNm,
      label: item.Label,
      oLabel: item.Label,
      JobId: selectedId,
      isEdit: false,
      file: null,
      imgLink: `${window.location.origin}/${FOLDER_JOB_FILE}${item.JobId}/${item.FileNm}`,
    }))
    originalDialogData = { ...dialogData }
    delete originalDialogData.Files
    originalTagIds = dialogData.Tags.map(item => ({ id: item.TagId, label: item.Name }))
    // originalPOIIds = dialogData.POIs.map(item => ({ id: item.POIId, label: item.Name }))
    setTagData(originalTagIds)
    // setTagData(dialogData.Tags.map(item=>item.TagId))
    setFileUploadData({ ...initFileUploadData(), serverFiles })
    // initCenter = { lat: dialogData.Lat, lng: dialogData.Lng }
    setExpensePOIDataTable(addIdForDataGrid(dialogData.ExpPOIs, "ExpPOIId"))
    setExpenseJobDataTable(addIdForDataGrid(dialogData.ExpJobs, "ExpJobId"))
    return dialogData
  }, [selectedId])

  const modInitDialogData = useMemo(() => {
    if (selectedCusId) {
      return {
        ...initDialogData,
        CusId: selectedCusId
      }
    } else {
      return initDialogData
    }
  }, [selectedCusId])

  useDialogOpen(dialogOpen, selectedId, jobApiNm.getJob, "JobId", setDialogData, modInitDialogData, modifyData)

  const validation = useMemo(() => ({
    Name: dialogData.Name === "",
    SName: dialogData.SName === "",
    Abbr: dialogData.Abbr.length > 5,
    CusId: dialogData.CusId == null,
    RcptNm: dialogData.RcptNm === "",
    RcptAddr: dialogData.RcptAddr === "",
    RcptTaxId: dialogData.RcptTaxId === "",
  }), [dialogData])

  const dialogDataProp = useCallback((name) => ({
    variant: "outlined",
    size: "small",
    name: name,
    label: jobColNm[name],
    value: dialogData[name] || "",
    error: validation[name],
    onChange: (e) => { setDialogData((oldState) => ({ ...oldState, [name]: e.target.value })) }
  }), [dialogData, validation])

  const insertUpdateJob = useCallback(async (dialogData) => {
    const dialogDataOnly = { ...dialogData }
    delete dialogDataOnly.Files
    let success = true
    let hasChange = false
    let result;
    let jobId = dialogData.JobId
    const postData = {
      ...dialogData,
      ExpPOIData: expensePOIdataTable,
      ExpJobData: expenseJobdataTable,
      OnTmBuff: dialogData.OnTmBuff || 0,
    }
    if (dialogData.JobId > 0) {
      if (JSON.stringify(originalDialogData) !== JSON.stringify(dialogDataOnly)) {
        result = await ax.post(jobApiNm.updateJob, postData);
        if (result.data) {
          success = true
          hasChange = true
        } else {
          success = false
        }
      }

      if (JSON.stringify(originalTagIds) !== JSON.stringify(tagData)) {
        const value = await ax.post(jobApiNm.updateJobTag, { JobId: jobId, TagIds: tagData.map(item => item.id) })
        if (value.data) {
          hasChange = true
        } else {
          success = false
        }
      }

    } else {
      dialogData.TagIds = tagData.map(item => item.id)
      result = await ax.post(jobApiNm.insertJob, postData);
      jobId = result.data
      hasChange = true
    }


    if (fileUploadData.addedFiles.length > 0 || fileUploadData.deletedFiles.length > 0) {
      hasChange = true
    }
    await saveFile({
      ax,
      alertWarning,
      fileUploadData,
      setFileUploadData,
      apiUpdateFileName: jobApiNm.updateJobFileName,
      apiDeleteFile: jobApiNm.deleteJobFile,
      apiAddFile: jobApiNm.uploadJobFile,
      key: "JobFileId",
      refKey: "JobId",
      refValue: jobId
    })


    loadMSData(ax, setMSData, null)

    if (success) {
      setDialogOpen(false);
    }
    if (hasChange) {
      onFinish()
    }
  }, [ax, setMSData, fileUploadData, onFinish, setDialogOpen, tagData, expenseJobdataTable, expensePOIdataTable])

  const deleteJob = useCallback((jobId) => {
    alertConfirmDelete(() => {
      ax.post(jobApiNm.deleteJob, { JobId: jobId }).then(value => {
        if (value.data) {
          onFinish()
          setDialogOpen(false);
          loadMSData(ax, setMSData, null)
        }
      })
    })
  }, [ax, setMSData, onFinish, setDialogOpen])

  const handleSelectCusId = useCallback((id) => {
    if (id === -1) {
      setDialogCusOpen(true)
      setDialogData(o => ({ ...o, CusId: null }))
    } else {
      setDialogData(o => ({ ...o, CusId: id }))
    }
  }, [])

  const onCusFinish = useCallback(async (id) => {
    await loadMSData(ax, setMSData, null)
    setDialogData(o => ({ ...o, CusId: id }))
  }, [ax, setMSData])

  const handleSelectPOIId = useCallback((id) => {
    if (id === -1) {
      setDialogPOIOpen(true)
      setDialogData(oldState => ({ ...oldState, POIId: null }))
    } else {
      setDialogData(oldState => ({ ...oldState, POIId: id }))
    }

  }, [])
  // const handleSelectPOIId = useCallback((newValue) => {
  
  //   const found = newValue.find(item => item.id === -1)
  //   if (found) {
  //     setDialogPOIOpen(true)
  //   } else {
  //     setPOIData(newValue)
  //   }
  // }, [])

  const onPOIFinish = useCallback(async (id) => {
    await loadMSData(ax, setMSData, null)
    setDialogData(o => ({ ...o, POIId: id }))

    // const newMsData = await loadMSData(ax, setMSData, null)
    
    // const newPOI = newMsData.poiCombo.find(item=>item.id===id)
    
    
    // if(!newPOI) return
    // setPOIData(o=>[...o, newPOI])
  }, [ax, setMSData])

  const handleIsHeadBrchChange = useCallback((e) => {
   
    if (+e.target.value === 1) {
     
      setDialogData(o => ({ ...o, IsHeadBrch: 1, BrchNo: "0" }))
    } else {
     
      setDialogData(o => ({ ...o, IsHeadBrch: 0 }))
    }
  }, [])

  const onSearchAddrFinish = useCallback((addrData) => {
    if (addrData) {
      setDialogData(o => ({
        ...o,
        Name: addrData.Name,
        Addr: addrData.Addr,
        RcptNm: addrData.Name,
        RcptAddr: addrData.Addr,
        RcptTaxId: addrData.TaxId,
      }))
    }
  }, [])

  const handleUseCusData = useCallback(() => {
    if (!dialogData.CusId) {
      return
    }
    ax.post(cusApiNm.getCustomer, { CusId: dialogData.CusId }).then(value => {
      if (value.data && value.data.length > 0) {
        const data = value.data[0]
        setDialogData(o => ({
          ...o,
          RcptNm: data.Name,
          RcptAddr: data.Addr,
          RcptTaxId: data.TaxId,
          RcptBrchNo: data.BrchNo,
          IsHeadBrch: data.BrchNo === 0 ? 1 : 0
        }))
      }
    })
  }, [ax, dialogData.CusId])

  const handleUseOwnData = useCallback(() => {
    const companyData = msData.serverData.CompanyData
   
    if (companyData) {
      setDialogData(o => ({
        ...o,
        RcptNm: companyData.NameEN,
        RcptAddr: companyData.AddrEN,
        RcptTaxId: companyData.TaxId,
      }))
    }
  }, [msData.serverData.CompanyData])

  const handleCopyJob = useCallback(() => {
    setDialogData(o => ({
      ...o,
      JobId: null
    }))
    setFileUploadData(initFileUploadData())
  }, [])

  const handleOpenExpenseJobDefault = useCallback(() => {
    jobId = dialogData.JobId
    setDialogExpenseJobDefaultOpen(true)
  }, [dialogData.JobId])

  const handleExpenseJobDefaultDialogFinish = useCallback(() => {

  }, [])

  const handleAddExpensePOI = useCallback(() => {
    jobId = dialogData.JobId
    setDialogExpensePOIOpen(true)
  }, [dialogData.JobId])

  const handleAddExpenseJob = useCallback(() => {
    jobId = dialogData.JobId
    setDialogExpenseJobOpen(true)
  }, [dialogData.JobId])

  const handleGetDistance = useCallback(()=>{
    if(!dialogData.POIId){
      alertError("กรุณาเลือกสถานที่ก่อน")
      return
    }
    const postData = {
      POIId: dialogData.POIId,
      allowExistData: 1
    }
    ax.post(poiApiNm.getDistanceFromCompanyToPOIId, postData).then(value=>{
      if(value.data){
        setDialogData(o=>({...o, DistWt: value.data}))
      }
    })
  }, [ax, dialogData.POIId])

  useEffect(() => {
    if (!dialogOpen) {
      setFileUploadData(initFileUploadData())
      setExpenseJobDataTable([])
      setExpensePOIDataTable([])
      // setPOIData([])
      // initCenter = null
    }
  }, [dialogOpen])

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth="lg" >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title={dialogData.JobId > 0 ? "แก้ไขงาน" : "เพิ่มงาน"}
        onDeleteClick={dialogData.JobId > 0 ? () => deleteJob(dialogData.JobId) : null}
      >
        {dialogData.JobId > 0 &&
          <Button sx={{ ml: 1 }} variant="contained" color="success" onClick={() => setDialogHistoryOpen(true)}>
            <HistoryRounded sx={{ mr: 1 }} />ประวัติ
          </Button>}
        {dialogData.JobId > 0 ? null :
          <Button color="secondary" variant="contained"
            sx={{ ml: 1 }} onClick={() => setDialogSearchAddrOpen(true)}>
            <SearchRounded sx={{ mr: 1 }} />ค้นหาที่อยู่
          </Button>
        }
        {
          dialogData.JobId ?
            <Button variant="contained" color="secondary" sx={{ ml: 1 }} onClick={handleCopyJob}>
              <ContentCopyRounded sx={{ mr: 1 }} /> คัดลอกเพิ่มงานใหม่
            </Button> : null
        }
      </DialogHeader>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={1} mt={2}>

          {/* <BoxFR>

          </BoxFR> */}
          <Box display="flex" flexDirection="row" width="100%" gap={2} alignItems="stretch">
            <Box display="flex" flexDirection="column" gap={1} width={300} >

              <CheckboxFormControl label={"Active"}
                checked={dialogData.IsActv === 1 ? true : false}
                onChange={e => setDialogData(o => ({ ...o, IsActv: e.target.checked ? 1 : 0 }))} />
              <ComboBox options={msData.cusComboWithAdd} label={jobColNm.CusSNm} required={true}
                selectedId={dialogData.CusId}
                setSelectedId={handleSelectCusId}
              />
              <TextFieldChangeLanguage {...dialogDataProp("Name")} required />
              <TextFieldChangeLanguage {...dialogDataProp("SName")} required />
              <TextFieldChangeLanguage {...dialogDataProp("Abbr")}
                helperText={dialogData.Abbr.length > 5 ? "รหัสไม่เกิน 5 ตัวอักษร" : ""} />
              {/* <TextFieldChangeLanguage {...dialogDataProp("Loc")} required /> */}
              {/* <ComboBoxMultiSelect label="สถานที่" value={poiData}
                setValue={handleSelectPOIId} refId={null} options={poiComboMod} /> */}

              <ComboBox options={poiComboMod} label="สถานที่"
                selectedId={dialogData.POIId}
                setSelectedId={handleSelectPOIId}
              />
              <BoxFR>
                <TextField {...dialogDataProp("DistWt")} {...endAdornmentProps("กม.")}  
                 value={dialogData.DistWt??""} onChange={(e)=>e.target.value===""?null: e.target.value}
                />
                <Button variant="contained"   onClick={handleGetDistance}><RouteRounded sx={{ mr: 1 }} />คำนวณ</Button>
              </BoxFR>
              <TextFieldChangeLanguage {...dialogDataProp("Addr")} multiline rows={2} />
              <TextFieldChangeLanguage {...dialogDataProp("CmdyTyp")} />
              <TextFieldChangeLanguage {...dialogDataProp("Rmk")} />
              <BoxFR width="100%">
                <CheckboxFormControl label={jobColNm.IsOnTm}
                  checked={dialogData.IsOnTm === 1 ? true : false}
                  onChange={e => setDialogData(o => ({ ...o, IsOnTm: e.target.checked ? 1 : 0 }))} />

                <TextFieldChangeLanguage {...dialogDataProp("OnTmBuff")} label={jobColNm.OnTmBuff} type="number" sx={{ flex: 1 }} />
              </BoxFR>
              <TextFieldChangeLanguage {...dialogDataProp("RcptPortCd")} />
              <TagBox value={tagData} setValue={setTagData} tblAbbr="JB" />
              <BoxFR sx={{ alignItems: "flex-start" }}>
                <TextFieldChangeLanguage {...dialogDataProp("LineGrpNm")} disabled fullWidth
                  helperText="*** สามารถเพิ่มได้โดย เพิ่ม Emily เป็นเพื่อนและดึง Emily เข้ากลุ่ม" />
                <IconButton sx={{ p: 0, pt: 0.2 }} onClick={() => setDialogData(o => ({ ...o, LineGrpNm: "", LineId: null }))}>
                  <CancelRounded fontSize="large" />
                </IconButton>
              </BoxFR>
            </Box>
            <Box display="flex" flexDirection="column" gap={1} width={400}>
              <BoxFR>
                <Typography>ขื่อ-ที่อยู่ออกใบเสร็จ</Typography>
                <Button variant="contained" onClick={handleUseCusData} disabled={!dialogData.CusId} sx={{ px: 0, flex: 1 }}>
                  <CloudDownloadRounded sx={{ mr: 1 }} />ที่อยู่ลูกค้า
                </Button>
                <Button variant="contained" onClick={handleUseOwnData} disabled={!dialogData.CusId} sx={{ px: 0, flex: 1 }}>
                  <CloudDownloadRounded sx={{ mr: 1 }} />ที่อยู่บริษัท
                </Button>
              </BoxFR>
              <BoxFR>
                <TextFieldChangeLanguage {...dialogDataProp("RcptNm")} required sx={{ flex: 1 }} />
              </BoxFR>
              <TextFieldChangeLanguage {...dialogDataProp("RcptAddr")} multiline rows={3} required />
              <TextField {...dialogDataProp('RcptTaxId')} />
              <BoxFR>

                <RadioGroup row value={dialogData.IsHeadBrch} onChange={handleIsHeadBrchChange}>
                  <FormControlLabel value={1} control={<Radio />} label="สำนักงานใหญ่" />
                  <FormControlLabel value={0} control={<Radio />} label="สาขาที่" />
                  <TextField size="small" {...dialogDataProp('RcptBrchNo')} disabled={dialogData.IsHeadBrch === 1}
                    label="เลขที่สาขา" type="number" sx={{ width: 80 }}
                    inputProps={{ style: { textAlign: 'center' } }} />
                </RadioGroup>
              </BoxFR>
              {/* <TextFieldChangeLanguage {...dialogDataProp("RcptTaxId")} required /> */}

              <TextFieldChangeLanguage {...dialogDataProp("CtDscp")} multiline rows={3} />
              <TextFieldChangeLanguage {...dialogDataProp("CtMailCont")} multiline rows={3} />
              <TextFieldChangeLanguage {...dialogDataProp("CtMailInv")} helperText="*** หาส่ง Email หลายคนให้คั่นด้วย จุลภาค(,) "
                multiline rows={3} />
              <BoxFR>
                <CheckboxFormControl label={jobColNm.IsGPSArvTm} checked={dialogData.IsGPSArvTm === 1} sx={{ width: 195 }}
                  onChange={e => setDialogData(o => ({ ...o, IsGPSArvTm: e.target.checked ? 1 : 0 }))} />
                <CheckboxFormControl label={jobColNm.IsGPSLevTm} checked={dialogData.IsGPSLevTm === 1}
                  onChange={e => setDialogData(o => ({ ...o, IsGPSLevTm: e.target.checked ? 1 : 0 }))} />
              </BoxFR>
              <BoxFR>
                <CheckboxFormControl label={jobColNm.IsChkTake} checked={dialogData.IsChkTake === 1} sx={{ width: 195 }}
                  onChange={e => setDialogData(o => ({ ...o, IsChkTake: e.target.checked ? 1 : 0 }))} />
                <CheckboxFormControl label={jobColNm.IsChkRtn} checked={dialogData.IsChkRtn === 1}
                  onChange={e => setDialogData(o => ({ ...o, IsChkRtn: e.target.checked ? 1 : 0 }))} />
              </BoxFR>
              <BoxFR>
                {true ? null : <Button variant="contained" onClick={handleOpenExpenseJobDefault}>คชจ. ประจำงาน</Button>/**hide it for now */}
                <Button variant="contained" onClick={handleAddExpensePOI}>กำหนด คชจ. ดำเนินงาน({expensePOIdataTable.length})</Button>
                <Button variant="contained" onClick={handleAddExpenseJob}>กำหนด คชจ. แจ้งหนี้({expenseJobdataTable.length})</Button>
              </BoxFR>
            </Box>
            <BoxFC flex={1} sx={{ gap: 1 }}>
              <FileUpload
                width="100%"
                options={msData.serverData.PreText.JobFiles || []}
                fileUploadData={fileUploadData}
                setFileUploadData={setFileUploadData}
              />
              <TextField {...dialogDataProp("Dscp")} multiline rows={15} />
            </BoxFC>
          </Box>
          {
            dialogData.JobId > 0 && <ModAccName modDte={dialogData.ModDte} modAcc={dialogData.ModAcc} />
          }
        </Box>

        <CustomerDialog state={{ dialogOpen: dialogCusOpen, selectedCusId: 0 }}
          fn={{
            setDialogOpen: setDialogCusOpen,
            onFinish: onCusFinish
          }} />
        <POIDialog selectedId={0} dialogOpen={dialogPOIOpen} setDialogOpen={setDialogPOIOpen}
          onFinish={onPOIFinish} lastFilter={null} />
        <SearchCompanyAddrDialog
          dialogOpen={dialogSearchAddrOpen}
          setDialogOpen={setDialogSearchAddrOpen}
          onFinish={onSearchAddrFinish} />
        <ExpenseJobDefaultDialog
          dialogOpen={dialogExpenseJobDefaultOpen}
          setDialogOpen={setDialogExpenseJobDefaultOpen}
          jobId={jobId}
          onFinish={handleExpenseJobDefaultDialogFinish} />
        <ExpensePOIDialog
          dialogOpen={dialogExpensePOIOpen}
          setDialogOpen={setDialogExpensePOIOpen}
          dataTable={expensePOIdataTable}
          setDataTable={setExpensePOIDataTable}
          jobId={jobId} />
        <ExpenseJobDialog
          dialogOpen={dialogExpenseJobOpen}
          setDialogOpen={setDialogExpenseJobOpen}
          dataTable={expenseJobdataTable}
          setDataTable={setExpenseJobDataTable}
          jobId={jobId} />
        <LogTableDialog
          tableName="job_log"
          idColNm="JobId"
          idValue={dialogData.JobId}
          excludeKeys={excludeKeys}
          colNm={jobColNm}
          title="ประวัติการแก้ไขข้อมูลงาน"
          dialogOpen={dialogHistoryOpen}
          setDialogOpen={setDialogHistoryOpen}
        />
      </DialogContent>
      <DialogFooter okText={dialogData.JobId > 0 ? "แก้ไขข้อมูล" : "เพิ่มข้อมูล"}
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={() => validate(validation) && insertUpdateJob(dialogData)} />
    </Dialog>
  )
}

export default React.memo(JobDialog)